import { IAuthState } from 'src/modules/Auth/store/types';
import * as moment from 'moment';
import _ from 'lodash';
import { IMatchWebiqResponse, IResult } from 'src/share/types/match';

export enum FetchType {
  Initial,
  Infinite,
  Filter,
  Sort,
  History,
}
export interface IWebiqMatches {
  sort: any[];
  sortName: string;
  page: number;
  size: number;
  dateRange: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
    focus: 'startDate' | 'endDate' | null;
  };
  data: IMatchWebiqResponse;
  loading: boolean;
  fetchingData: boolean;
  pages: number;
  deleting: boolean;
}

export const initialMatchResults: IMatchWebiqResponse = {
  matches: {
    total: 0,
    results: [],
  },
};

export const initialState: IWebiqMatches = {
  sort: [{ createdAt: 'desc' }],
  sortName: 'createdAt',
  page: 0,
  size: 12,
  dateRange: {
    startDate: null,
    endDate: null,
    focus: null,
  },
  data: _.cloneDeep(initialMatchResults),
  loading: true,
  fetchingData: false,
  pages: 0,
  deleting: false,
};

export interface IMatchesViewProps {
  auth: IAuthState;
  history: any;
  location: Location;
}

export interface IRequestMatchesRange {
  createdAt: { gte: number; lte: number };
}

export interface IRequestMatches {
  page: number;
  size: number;
  sort: Array<{ [key: string]: { order: 'asc' | 'desc' } }>;
  range: IRequestMatchesRange | null;
}

export interface IMatchCardState {
  showDelete: boolean;
}

export interface IDate {
  gte: number;
  lte: number;
}

export interface IRange {
  createdAt: IDate;
}

interface ICardProps {
  auth: IAuthState;
  history: any;
  deleteMatch: (matchId: string) => () => void;
  deleting: boolean;
}

export interface IMatchCardProps extends ICardProps {
  matchData: any;
}

export interface IWebiqMatchCardProps extends ICardProps {
  matchData: IResult;
}



// WEBPACK FOOTER //
// ./src/modules/AdHocTools/Webiq/types.ts